import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-038443f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "risk-view-table-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "cm-ellipsis-line-one"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupTreeSelector = _resolveComponent("GroupTreeSelector")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_SafetyTags = _resolveComponent("SafetyTags")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Copy = _resolveComponent("Copy")!
  const _component_TerminalIconName = _resolveComponent("TerminalIconName")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_EllipsisText = _resolveComponent("EllipsisText")!
  const _component_HandleRiskItem = _resolveComponent("HandleRiskItem")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _directive_intel_link = _resolveDirective("intel-link")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SearchFilterBar, {
      style: {"padding":"16px 16px 0","background-color":"var(--cm-color-card-bg)"},
      modelValue: _ctx.queryParams,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryParams) = $event)),
      "search-input-opt": { style: 'min-width: 320px' },
      "form-columns": _ctx.filterFormColumns,
      "show-search": true,
      "search-placeholder": _ctx.$t('common.phMd5RiskFull'),
      "popover-threshold": 2,
      onSearch: _ctx.handleSearch,
      onQuery: _ctx.handleQuery,
      onReset: _ctx.handleReset
    }, {
      group_id: _withCtx(() => [
        _createVNode(_component_GroupTreeSelector, {
          width: "100%",
          onSelected: _ctx.updateGroupId
        }, null, 8, ["onSelected"])
      ]),
      actions: _withCtx(() => [
        (_ctx.handleText)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              disabled: !_ctx.selectedList.length,
              onClick: _ctx.batchProcessResult
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.handleText), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.viewMode === _ctx.TableViewMode.preview)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "small",
              class: "cm-ui-ml10",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.viewAllRisks')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "form-columns", "search-placeholder", "onSearch", "onQuery", "onReset"]),
    _createElementVNode("div", {
      class: "table-wrapper",
      style: _normalizeStyle({ height: _ctx.viewMode === _ctx.TableViewMode.full ? 'calc(100% - 40px)' : '400px' })
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "empty-text": _ctx.$t('common.noData'),
        "min-width": "100%",
        height: _ctx.viewMode === _ctx.TableViewMode.full ? '100%' : undefined,
        data: _ctx.tableData,
        "tooltip-effect": "light",
        onSortChange: _ctx.handlerSort,
        onSelectionChange: _ctx.selectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "selection" }),
          _createVNode(_component_el_table_column, {
            width: "150",
            label: _ctx.$t('safeProtectionModule.riskType')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.riskTypeLabelI18n[scope.row.risk_type] ?? '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": 150,
            "show-overflow-tooltip": true,
            label: _ctx.$t('safeProtectionModule.riskItem')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.riskItemLabelMap[scope.row.risk_item] ?? '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "180",
            width: "150",
            label: _ctx.$t('ransomwareIncident.threatType')
          }, {
            default: _withCtx((scope) => [
              (scope.row?.tags && scope.row?.tags?.length)
                ? (_openBlock(), _createBlock(_component_SafetyTags, {
                    key: 0,
                    data: scope.row?.tags,
                    max: 2
                  }, null, 8, ["data"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" -- ")
                  ], 64))
            ]),
            _: 1
          }, 8, ["label"]),
          (!_ctx.HIDE_FUNC.threatIntel)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "100",
                width: "150",
                label: _ctx.$t('safeProtectionModule.threatStatus')
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    size: "small",
                    style: _normalizeStyle([{"color":"#fff","border":"none"}, `background: ${_ctx.getStatusColor(scope.row.kscore)}`]),
                    class: "cm-score-tag"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getStatusTitle(scope.row.kscore)), 1)
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            "min-width": "200",
            prop: "risk_name",
            label: _ctx.$t('safeProtectionModule.riskDesc'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(`【${scope.row.risk_name}】${scope.row.virus_info?.description}`), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "100",
            label: _ctx.$t('safeProtectionModule.processResult')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.processResultLabelI18n[scope.row.handle_status] ?? '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: _ctx.$t('safeProtectionModule.discoverTime'),
            prop: "scan_time",
            sortable: "custom"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatTimeStamp(scope.row.scan_time, 'YYYY-MM-DD HH:mm')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "scan_type",
            "min-with": "150",
            width: "150",
            label: _ctx.$t('safeProtectionModule.scanType')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.scanTypeLabelI18n[scope.row.scan_type] ?? '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: _ctx.$t('listColumns.fileMd5'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_Copy, { reverse: "" }, {
                default: _withCtx(() => [
                  (_ctx.getVirusMd5(scope.row))
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
                        [_directive_intel_link, _ctx.getVirusMd5(scope.row)]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, "--"))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "200",
            prop: "computer_name",
            label: _ctx.$t('listColumns.computerName')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_TerminalIconName, {
                computer_name: scope.row.computer_name,
                system_type: scope.row.system_type,
                login_status: scope.row.login_status
              }, null, 8, ["computer_name", "system_type", "login_status"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            prop: "user_mark",
            label: _ctx.$t('listColumns.userMark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            prop: "group_name",
            label: _ctx.$t('listColumns.groupName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "155",
            label: _ctx.$t('listColumns.ipAddress')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_IPColumn, {
                cip: scope.row.client_ip,
                sip: scope.row.system_ip
              }, null, 8, ["cip", "sip"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: _ctx.$t('safeProtectionModule.captureEngine')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.virus_info.engine), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "150",
            label: _ctx.$t('listColumns.filePath'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_Copy, { reverse: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_EllipsisText, {
                    disabled: "",
                    content: _ctx.virusPayloadFilePath(scope.row)
                  }, null, 8, ["content"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "200",
            label: _ctx.$t('listColumns.fileSize'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.virusPayloadFileSize(scope.row) || '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_HandleRiskItem, {
            "process-type": _ctx.queryParams.handle_status,
            "action-type": _ctx.actionType,
            "onUpdate:actionType": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actionType) = $event)),
            modelValue: _ctx.visible,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
            single: _ctx.single,
            "onUpdate:single": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.single) = $event)),
            selectedList: _ctx.selectedList,
            onRefresh: _ctx.handleRiskRefresh
          }, null, 8, ["process-type", "action-type", "modelValue", "single", "selectedList", "onRefresh"])
        ]),
        _: 1
      }, 8, ["empty-text", "height", "data", "onSortChange", "onSelectionChange"])), [
        [_directive_loading, _ctx.isLoading],
        [_directive_load_more, _ctx.loadMoreData]
      ])
    ], 4),
    (_ctx.viewMode === _ctx.TableViewMode.full)
      ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
          key: 0,
          loading: _ctx.isLoading,
          current: _ctx.tableData.length,
          total: _ctx.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"]))
      : _createCommentVNode("", true)
  ]))
}